import { Component } from '@angular/core';

@Component({
  selector: 'app-info',
  templateUrl: 'info.component.html'
})
export class InfoComponent {
}
